import WorkspaceSelector from "../Helper/WorkspaceSelector"
/* Requesthelper to simplify api calls */
const APIController = () => {
    const { currentWorkspace } = WorkspaceSelector()
    const mainURL = window?.RUNTIME_CONFIG?.BACKEND_URL || "http://localhost:8080";

    /* Request without any relevant responce bodys */
    const basicRequest = async (path, method = "GET", body = null, needToken = true) => {
        const data = await request(path, method, body, needToken)
        return data
    }

    /* Request with json responce */
    const jsonRequest = async (path, method = "GET", body = null, needToken = true) => {
        const responce = await request(path, method, body, needToken)
        if (responce.ok) {
            const data = await responce.json()
            return data
        }
        return null
    }

    const request = async (path, method, body, needToken) => {
        const headers = {
            "Content-Type": "application/json",
        };

        if (needToken) {
            const token = localStorage.getItem("token");
            if (token) {
                headers["Authorization"] = token;
            }
        }

        const fetchOptions = {
            method: method,
            headers: headers,
            body: body ? JSON.stringify(body) : null,
        };

        if (needToken) {
            fetchOptions.mode = "cors";
        }

        const response = await fetch(`${mainURL}${path}`, fetchOptions);
        return response;
    };

    const getWorkspaceId = async () => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user && user?.workspace[currentWorkspace()]?.workspaceDTO?.id) {
            return user.workspace[currentWorkspace()].workspaceDTO.id;
        }
        return null
    }

    return {
        basicRequest,
        jsonRequest,
        getWorkspaceId
    }
}

export default APIController